/* eslint-disable */
import type { Reducer } from 'react';
import type { TrackingService } from '../../models/tracking-service';

export type State = {
  trackingService: TrackingService | null;
};

export enum ActionTypes {
  setTrackingService,
}

export type Action = {
  type: ActionTypes;
  payload: TrackingService | null;
};

const reducer: Reducer<State, Action> = (state: State, action: Action) => {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.setTrackingService:
      return { ...state, trackingService: payload };

    default:
      throw new Error(`Invalid action type: ${String(type)}`);
  }
};

export default reducer;
